import type { IconComponent } from "@shared/components/menus/DrilldownMenu"
import { cx } from "@shared/components/untitledui/util/cx"

export interface ChoiceCardFaceProps {
  label: string
  description?: string
  /** Optional illustrative icon at the left of the card. */
  icon?: IconComponent
}

export function ChoiceCardFace({ label, description, icon: Icon }: ChoiceCardFaceProps) {
  return (
    <span className={cx("flex gap-3", Icon ? "items-center" : "items-start")}>
      {Icon ? <Icon className="size-8 shrink-0" /> : null}

      <span className="flex min-w-0 flex-col">
        <span className="text-sm font-semibold text-gray-700">{label}</span>
        {description ? (
          <span className="text-sm font-normal text-gray-600">{description}</span>
        ) : null}
      </span>
    </span>
  )
}
